"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataFormatTypes = void 0;
/* eslint-disable max-len */
/**
 * Supported `accept` headers for controlling the format
 * of the data returned from Domo.
 *
 * See [developer.domo.com](https://developer.domo.com/docs/dev-studio-references/data-api#Data%20Formats)
 * for more details.
 */
var DataFormatTypes;
(function (DataFormatTypes) {
    DataFormatTypes["default"] = "application/array-of-objects";
    DataFormatTypes["arrayOfObjects"] = "application/array-of-objects";
    DataFormatTypes["json"] = "application/json";
    DataFormatTypes["csv"] = "text/csv";
    DataFormatTypes["excel"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    DataFormatTypes["plain"] = "text/plain";
})(DataFormatTypes = exports.DataFormatTypes || (exports.DataFormatTypes = {}));
